<template>
  <div>
    <div v-if="splashPage === null">
      Loading...
    </div>
    <div v-else>
      <nav class="border-b border-gray-300 px-2 md:px-0 py-2">
        <div class="flex justify-between items-center">
          <div class="">
            <div class="hidden md:flex text-sx">
              <router-link :to="{name:'home'}">Home</router-link>
              <span class="mx-2">/</span>
              <router-link :to="{name:'splash_pages'}">splash pages</router-link>
              <span class="mx-2">/</span>
              <span>{{ splashPage.name }}</span>
            </div>
            <div class="text-xl">
              {{ splashPage.name }}
            </div>
          </div>
          <div class="flex relative float-right">
            <button v-if="splashPage.type !=null && !splashPage.published && $store.getters.can('publish_splash_pages')"
                    @click="publishPage( splashPage)"
                    class="border rounded text-xs mr-2 border-blue-500 text-blue-500 p-1 hover:bg-blue-500 hover:text-white">
              Publish
            </button>
            <a v-if="splashPage.type !=null && splashPage.page_url != null && $store.getters.can('view_splash_pages')"
               target="_blank"
               class="border rounded text-xs mr-2 border-blue-500 text-blue-500 p-1 hover:bg-blue-500 hover:text-white"
               :href="splashPage.page_url">View page</a>
            <button @click="deletePage(splashPage)" v-if="$store.getters.can('delete_splash_pages')"
                    class="border rounded text-xs border-red-500 text-red-500 p-1 hover:bg-red-500 hover:text-white">
              Delete
            </button>
          </div>
        </div>
      </nav>
      <div class="py-4">
        <div class="">
          <div class="text-xl font-bold">{{ splashPage.name }}</div>
          <div class="mt-2">
            <div class="">{{ splashPage.description }}</div>
          </div>
        </div>
        <div v-if="splashPage.type !=null" class="mt-8 md:mt-0 bg-white shadow border rounded ">
          <div class="flex text-sm bg-gray-200 text-gray-700  flex-wrap">
            <router-link :to="{name:'splash_page_details', params: {pageId: pageId, path:'settings'}}"
                         class="px-3 py-4 hover:text-blue-500">Details
            </router-link>
            <router-link v-if="splashPage.configs.length > 0"
                         :to="{name:'splash_page_details', params: {pageId: pageId, path:'configurations'}}"
                         class="px-3 py-4 hover:text-blue-500">Options
            </router-link>
            <router-link v-if="splashPage.type ===2"
                         :to="{name:'splash_page_details', params: {pageId: pageId, path:'html'}}"
                         class="px-3 py-4 hover:text-blue-500">HTML
            </router-link>
            <router-link v-else
                         :to="{name:'splash_page_details', params: {pageId: pageId, path:'builder'}}"
                         class="px-3 py-4 hover:text-blue-500">Builder
            </router-link>
            <router-link :to="{name:'splash_page_details', params: {pageId: pageId, path:'styles'}}"
                         class="px-3 py-4 hover:text-blue-500">Styles
            </router-link>
            <router-link :to="{name:'splash_page_details', params: {pageId: pageId, path:'scripts'}}"
                         class="px-3 py-4 hover:text-blue-500">Scripts
            </router-link>
            <router-link :to="{name:'splash_page_details', params: {pageId: pageId, path:'presentation'}}"
                         class="px-3 py-4 hover:text-blue-500">Presentation
            </router-link>
          </div>
          <div class="mx-4 mt-4 mb-4">
            <CodeEditorComponent v-if="path === 'html'" mode="text/html" :code="splashPage.html == null ? '<html>\n'+
'  <head>\n'+
'    <title>Brandfi splash page</title>\n'+
'  </head>\n'+
'  <body>\n'+ 
'  </body>\n'+
'</html>' : splashPage.html"
                                 :page-id="pageId"/>
            <CodeEditorComponent  v-else-if="path === 'styles'" mode="text/css"
                                 :code="splashPage.css == null ? '.{\n}' : splashPage.css"
                                 :page-id="pageId"/>

            <CodeEditorComponent  v-else-if="path === 'scripts'" mode="text/javascript"
                                 :code="splashPage.custom_scripts == null ? '<script>\n</script>' :    splashPage.custom_scripts"
                                 :page-id="pageId"/>
            <SplashPageBuilder :styling-template="splashPage.css_template" :page-id="pageId"  v-else-if="path === 'builder'"/>

            <div  v-else-if="path === 'presentation'">
              <h2 class="text-lg font-semibold">Presentation</h2>
              <DisplayOptions class="my-4" :page-id="pageId"/>
            </div>
            <PageConfigurations :page-id="pageId" :options="splashPage.configs"
                                v-else-if="path === 'configurations'"/>
            <div v-else>
              <div class="mt-4 mb-6">
                <h2 class="text-lg font-semibold">Details</h2>
                <UpdateOrCreateSplashPageComponent class="my-4" :page-id="pageId"/>
              </div>
            </div>

          </div>
        </div>
        <div v-else class="">
          <SetupPageComponent :page-id="pageId"/>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import SplashPageService from "../../services/splashPage.service"
import SplashPageBuilder from "../../components/SplashPageBuilder";
import UpdateOrCreateSplashPageComponent from "../../components/UpdateOrCreateSplashPageComponent";
import SetupPageComponent from "../../components/SetupPageComponent";
import CodeEditorComponent from "../../components/CodeEditorComponent";
import PageConfigurations from "./PageConfigurations";
import DisplayOptions from "./DisplayOptions";

export default {
  name: "SplashPageDetails",
  components: {
    DisplayOptions,
    PageConfigurations,
    CodeEditorComponent,
    SetupPageComponent, UpdateOrCreateSplashPageComponent, SplashPageBuilder
  },
  props: {
    pageId: String,
    path: String
  },
  data() {
    return {
      splashPage: null,
      screenshot: null,
      errors: []
    }
  },
  watch: {
    pageId: function () {
      this.getSplashPage();
    },
    errors(errors) {
      this.$root.$emit("alert_error", errors)
    }
  },
  mounted() {
    this.getSplashPage();
    this.$root.$on("refresh_page", () => {
      this.getSplashPage();
    });
  },
  methods: {
    getSplashPage() {
      SplashPageService.getOne(this.pageId)
          .then(response => this.splashPage = response.page)
          .catch(() => this.errors.push("An error occurred while connecting to server"))
    },
    deletePage() {
      SplashPageService.deletePage(this.pageId)
          .then(response => {
                if (response != null) {
                  this.$store.dispatch("setAlert", {
                    type: "success",
                    alert: [response]
                  })
                  this.$router.replace("/splash_pages")
                }
              }
          )
          .catch(() => this.errors.push("An error occurred while connecting to server"))
    },
    publishPage() {
      SplashPageService.publishPage(this.pageId)
          .then(response => {
            if (response != null) {
              this.$root.$emit("alert_success", [response.message])
              this.splashPage = response.page;
            }
          })
          .catch(() => this.errors.push("An error occurred while connecting to server"))
    }
  }
}
</script>
<style scoped>
.dropdown:hover .dropdown-menu {
  display: block;
}
</style>